import { Alert, Flex } from "@chakra-ui/react";
import { RiEmotionSadLine } from "@remixicon/react";
import * as Sentry from "@sentry/react";
import { ReactNode } from "react";
import {
  ErrorBoundary as ErrorBoundaryModule,
  ErrorBoundaryProps,
  FallbackProps,
} from "react-error-boundary";

function Fallback({ error }: FallbackProps) {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <Alert alignItems={"flex-start"} gap="4" status="error">
      <Flex direction={"column"} gap="4">
        <Flex alignItems={"center"} gap="2">
          <RiEmotionSadLine size="24" /> Sorry, an error has occurred.
          We&apos;re looking into it!
        </Flex>

        {import.meta.env.DEV && <pre>{error.stack}</pre>}
      </Flex>
    </Alert>
  );
}

const logError: ErrorBoundaryProps["onError"] = function logError(error, info) {
  Sentry.captureException(error, { extra: info });
};

export default function ErrorBoundary(props: { children: ReactNode }) {
  return (
    <ErrorBoundaryModule FallbackComponent={Fallback} onError={logError}>
      {props.children}
    </ErrorBoundaryModule>
  );
}
